<script lang="ts">
  interface Links {
    text: string;
    link: string;
    svg: any;
  }

  export let links: Links[];
</script>

<style lang="scss">
  ul {
    display: flex;
    margin: 0;
    padding: 12px 0 0;

    @include breakpoint(md) {
      padding: 3px 0 0;
    }
  }
  li {
    list-style: none;
    padding-right: 24px;

    @include breakpoint(md) {
      padding-left: 16px;
      padding-right: 0;
    }
  }
  a {
    text-decoration: none;
  }
  a:hover {
    path {
      fill: $on-surface-30;
      cursor: pointer;
    }
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
</style>

<ul>
  {#each links as { link, text, svg }}
    <li>
      <a href={link} aria-label={text}>
        <span class="sr-only">{text}</span>
        <svg
          role="presentation"
          width="25"
          height="24"
          viewBox={text === "TikTok" ? "0 0 50 50" : "0 0 24 24"}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d={svg} fill="var(--on-surface)" />
        </svg>
      </a>
    </li>
  {/each}
</ul>
